import ApiService from "../../common/services/ApiService";

const api = new ApiService();

export const getVcms = async () => {
   try {
      const vcms = await api.query(`/api/v1/vcms?q[status_eq]=in_review&per_page=25&q[s]=status_updated_at+asc`);
      return vcms.data;
    } catch (error) {
    } 
}

export const getLatestVcm = async (userId) => {
   try {
      const vcms = await api.query(`/api/v1/vcms?q[status_does_not_match_any][]=approved&q[status_does_not_match_any][]=closed&q[s][]=year+desc&q[s][]=revision_number+desc`);
      return vcms.data;
    } catch (error) {
    } 
}